/**
 * An event is described by the data it carries and the response a listener may resolve it with.
 * Notification events carry no response; request events do.
 */
export interface EventDefinition<TData = void, TResponse = void> {
    data: TData;
    response: TResponse;
}

export type Notification<TData = void> = EventDefinition<TData, void>;
export type Request<TData, TResponse> = EventDefinition<TData, TResponse>;

export type EventMap = Record<string, EventDefinition<unknown, unknown>>;

export type EventData<M extends EventMap, K extends keyof M> = M[K]["data"];
export type EventResponse<M extends EventMap, K extends keyof M> = M[K]["response"];

export class UnhandledEventError extends Error {
    constructor(public readonly eventType: string) {
        super(`No listener handled the request event "${eventType}"`);
        this.name = "UnhandledEventError";
    }
}
